function applyOpenHoursState() {
  const hours = getSupportHoursForToday();
  const $teltop = $(".top-navigation-contacts .project-phone");
  const $teltopHeader = $(".responsive-tools .project-phone");
  const $msg = $(".contactHours .contactOpen");
  const $tel = $(".top-navigation-contacts, .contact-wrap");

  if (!hours) {
    // Zavřeno -> žádné hodiny nejsou definované
    $msg.removeClass("haveOpen").text(closeDaysText);
    $tel.removeClass("haveOpen");
    $teltop.removeClass("haveOpen");
    $teltopHeader.removeClass("haveOpen");
    return;
  }

  if (isSupportOnline(hours)) {
    // Otevřeno právě teď
    $msg.addClass("haveOpen");
    $tel.addClass("haveOpen");
    $teltop.addClass("haveOpen");
    $teltopHeader.addClass("haveOpen");
    return;
  }

  // Dnes je otevřeno, ale teď mimo provozní dobu
  $msg.removeClass("haveOpen");
  $tel.removeClass("haveOpen");
  $teltop.removeClass("haveOpen");
  $teltopHeader.removeClass("haveOpen");
}

applyOpenHoursState();

function fixedHolidays(year) {
  return [`${year}-01-01`, `${year}-05-01`, `${year}-05-08`, `${year}-07-05`, `${year}-07-06`, `${year}-09-28`, `${year}-10-28`, `${year}-11-17`, `${year}-12-24`, `${year}-12-25`, `${year}-12-26`];
}

function getEasterDates(year) {
  let f = Math.floor,
    a = year % 19,
    b = f(year / 100),
    c = year % 100,
    d = f(b / 4),
    e = b % 4,
    g = f((8 * b + 13) / 25),
    h = (19 * a + b - d - g + 15) % 30,
    i = f(c / 4),
    k = c % 4,
    l = (32 + 2 * e + 2 * i - h - k) % 7,
    m = f((a + 11 * h + 22 * l) / 451),
    month = f((h + l - 7 * m + 114) / 31),
    day = ((h + l - 7 * m + 114) % 31) + 1;
  const sunday = new Date(year, month - 1, day);
  const monday = new Date(year, month - 1, day + 1);
  return [sunday.toISOString().slice(0, 10), monday.toISOString().slice(0, 10)];
}

function toMinutes(time) {
  if (!time) return null;
  const [h, m] = time.split(":");
  return parseInt(h) * 60 + parseInt(m);
}

function getSupportHoursForToday() {
  const now = new Date();
  const year = now.getFullYear();
  const today = now.toISOString().slice(0, 10);
  const weekday = now.getDay() === 0 ? 7 : now.getDay();
  if (manualExtendedHours[today]) {
    return manualExtendedHours[today];
  }
  if (manualClosedDays[today]) {
    return null;
  }
  const holidays = [...fixedHolidays(year), ...getEasterDates(year)];
  if (holidays.includes(today)) {
    return null;
  }
  return supportHours[weekday] || null;
}

function isSupportOnline(hours) {
  if (!hours) return false;

  const now = new Date();
  const currentMinutes = now.getHours() * 60 + now.getMinutes();

  const open = toMinutes(hours.open);
  const close = toMinutes(hours.close);

  return currentMinutes >= open && currentMinutes < close;
}

function isHoliday(date) {
  const year = date.getFullYear();
  const iso = date.toISOString().slice(0, 10);
  const holidays = [...fixedHolidays(year), ...getEasterDates(year)];
  return holidays.includes(iso);
}

function isWorkingDay(date) {
  const day = date.getDay(); // 0 = ne
  return day !== 0 && day !== 6 && !isHoliday(date);
}

function afterDeliveryCutoff(now) {
  const [h, m] = deliveryHours.split(":").map(Number);
  return now.getHours() * 60 + now.getMinutes() >= h * 60 + m;
}

function addWorkingHours(startDate, hoursToAdd) {
  const date = new Date(startDate);
  let remaining = hoursToAdd;

  while (remaining > 0) {
    date.setHours(date.getHours() + 1);

    if (isWorkingDay(date)) {
      remaining--;
    }
  }

  return date;
}

function formatDeliveryDate(date, year = false) {
  const today = new Date();
  today.setHours(0, 0, 0, 0);

  const target = new Date(date);
  target.setHours(0, 0, 0, 0);

  const diffDays = Math.round((target - today) / (1000 * 60 * 60 * 24));

  const day = date.getDate();
  const month = date.getMonth() + 1;
  const yearValue = date.getFullYear();
  // if (diffDays === 1) return `zítra ${day}. ${month}. u tebe`;
  // if (diffDays === 2) return `pozítří ${day}. ${month}. u tebe`;

  return `${day}. ${month}. ${year ? `${yearValue}` : ""}`;
}

function getDeliveryDateByAvailability(availabilityText) {
  const hours = deliveryMap[availabilityText];
  if (!hours) return null;

  const now = new Date();

  // po cut-off → začínáme až další pracovní den
  if (afterDeliveryCutoff(now)) {
    do {
      now.setDate(now.getDate() + 1);
    } while (!isWorkingDay(now));
    now.setHours(9, 0, 0, 0); // start dne
  }

  return addWorkingHours(now, hours);
}
